import { modalType } from '../../util/ModalUtil';
import { ModalHeader } from '../../component/ModalRef';
import InputBox from '../../component/InputBox';
import TimePickerBox from '../../component/TimePickerBox';
import { useEffect, useState } from 'react';
import SelectionBox from '../../component/SelectionBox';
import CodeUtil from '../../util/CodeUtil';
import { CODE_GROUP_ID } from '../../constant/Constant';
import { ScheduleType, date2SaveTime, date2WeekdayCd, weekdayCdSaveTime2Date } from '../../util/TimeTableUtil';
import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import { actionAdd, actionEdit, actionRemove, actionSearch } from '../../module/component/ScheduleModule';
import { checkTimeRange } from '../../component/schedule/Schedule';
import { useDispatch } from 'react-redux';
import CommunityDeleteButtonBox from '../../component/buttons/CommunityDeleteButtonBox';

const ScheduleModal = ({ type, event, popupRef, modalRef, semesterId, userId }) => {
    const dispatch = useDispatch();
    const uid = event.uid;
    const scheduleTypeCd = event.scheduleTypeCd;
    const [subjectNm, setSubjectNm] = useState(event.subjectNm);
    const [lessonUniversityCd, setLessonUniversityCd] = useState(event.lessonUniversityCd);
    const [weekdayCd, setWeekdayCd] = useState(date2WeekdayCd(event.start));
    const [bgnTime, setBgnTime] = useState(date2SaveTime(event.start));
    const [endTime, setEndTime] = useState(date2SaveTime(event.end));

    useEffect(() => {}, []);

    const handleCancel = () => {
        modalRef.current.close();
    };

    const handleRemove = () => {
        if (scheduleTypeCd != ScheduleType.CLASS) {
            dispatch(
                actionRemove({
                    params: { uid },
                    callback: () => {
                        dispatch(actionSearch({ params: { semesterId } }));
                        modalRef.current.close();
                    },
                }),
            );
        }
    };

    const handleConfirm = () => {
        if (scheduleTypeCd != ScheduleType.CLASS) {
            if (
                checkTimeRange(
                    weekdayCdSaveTime2Date(weekdayCd, bgnTime),
                    weekdayCdSaveTime2Date(weekdayCd, endTime),
                    popupRef,
                )
            ) {
                if (type == modalType.ADD) {
                    dispatch(
                        actionAdd({
                            data: {
                                semesterId,
                                userId,
                                subjectNm,
                                weekdayCd,
                                bgnTime,
                                endTime,
                            },
                            callback: () => {
                                dispatch(actionSearch({ params: { semesterId } }));
                                modalRef.current.close();
                            },
                        }),
                    );
                } else {
                    dispatch(
                        actionEdit({
                            data: {
                                uid,
                                semesterId,
                                userId,
                                subjectNm,
                                weekdayCd,
                                bgnTime,
                                endTime,
                            },
                            callback: () => {
                                dispatch(actionSearch({ params: { semesterId } }));
                                modalRef.current.close();
                            },
                        }),
                    );
                }
            }
        } else {
            modalRef.current.close();
        }
    };
    return (
        <>
            <ModalHeader
                title={`${
                    scheduleTypeCd == ScheduleType.CLASS ? '혁신융합대학사업(미래자동차) 강의' : '개인별 수강'
                } 스케줄 ${type == modalType.ADD ? '등록' : ''}`}
                modalRef={modalRef}
            />
            <div className='modal-body'>
                <div className='con-inner'>
                    <div>
                        <div className='form-box-row'>
                            <InputBox
                                title={scheduleTypeCd == ScheduleType.CLASS ? '교과목' : '수강 스케줄 메모'}
                                value={subjectNm}
                                onChange={(e) => setSubjectNm(e.target.value)}
                                disabled={scheduleTypeCd == ScheduleType.CLASS}
                                maxLength={128}
                            />
                        </div>
                        {scheduleTypeCd == ScheduleType.CLASS ? (
                            <div className='form-box-row'>
                                <SelectionBox
                                    title='개설대학'
                                    value={lessonUniversityCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                                    onChange={(e) => setLessonUniversityCd(e.target.value)}
                                    useAll={false}
                                    disabled
                                />
                            </div>
                        ) : (
                            <></>
                        )}
                        <div className='form-box-row'>
                            <div className='form-box'>
                                <SelectionBox
                                    title='종류'
                                    useAll={false}
                                    value={scheduleTypeCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SCHEDULE_TYPE)}
                                    onChange={(e) => {}}
                                    disabled
                                />
                            </div>
                            <div className='form-box'>
                                <SelectionBox
                                    title='요일'
                                    useAll={false}
                                    value={weekdayCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.WEEKDAY)}
                                    onChange={(e) => setWeekdayCd(e.target.value)}
                                    disabled={event.scheduleTypeCd == ScheduleType.CLASS}
                                />
                            </div>
                            <div className='form-box'>
                                <TimePickerBox
                                    title='시작시각'
                                    value={bgnTime}
                                    onChangeTimeString={(timeString) => setBgnTime(timeString)}
                                    disabled={event.scheduleTypeCd == ScheduleType.CLASS}
                                />
                            </div>
                            <div className='form-box'>
                                <TimePickerBox
                                    title='종료시각'
                                    value={endTime}
                                    onChangeTimeString={(timeString) => setEndTime(timeString)}
                                    disabled={event.scheduleTypeCd == ScheduleType.CLASS}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    {scheduleTypeCd != ScheduleType.CLASS ? (
                        <>
                            <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                            {type == modalType.ADD ? (
                                <></>
                            ) : (
                                <CommunityDeleteButtonBox title='삭제' onClick={(e) => handleRemove()} />
                            )}
                        </>
                    ) : (
                        <></>
                    )}
                    <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                </div>
            </div>
        </>
    );
};

export default ScheduleModal;
